var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_vm._m(0),_c('p',[_vm._v(" "+_vm._s(_vm.$t("Footer"))+" ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"linkedIn"},[_c('a',{attrs:{"href":"https://www.linkedin.com/in/pascal-de-lucia-4a32b818/","target":"_blank"}},[_c('img',{attrs:{"src":require("../assets/LinkedIn_icon_circle.png"),"alt":"../assets/LinkedIn_icon_circle.png"}})])])
}]

export { render, staticRenderFns }